module.exports = __webpack_public_path__ + "media/images/icons/material/microphone-484d6c06fbaedaf6b1c776b1cad9b623.svg";